import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { XCircle } from 'lucide-react';

export const CancelPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const intakeId = searchParams.get('intake_id');

  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ backgroundColor: 'var(--color-bg)' }} data-testid="cancel-page">
      <div className="card max-w-2xl w-full p-10 text-center">
        <div className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6" style={{ backgroundColor: 'var(--color-border)' }}>
          <XCircle className="w-12 h-12" style={{ color: 'var(--color-muted)' }} />
        </div>

        <h1 className="mb-4" style={{ color: 'var(--color-text)' }} data-testid="cancel-title">
          Payment Cancelled
        </h1>

        <p className="text-lg mb-6" style={{ color: 'var(--color-muted)' }}>
          Your payment was cancelled. No charges have been made.
        </p>

        <div className="rounded-lg p-6 mb-8" style={{ backgroundColor: 'var(--color-bg)', border: '1px solid var(--color-border)' }}>
          <p className="mb-3" style={{ color: 'var(--color-muted)' }}>
            If you experienced any issues during checkout or have questions about the service, please don't hesitate to contact us.
          </p>
          <p style={{ color: 'var(--color-muted)' }}>
            Your project information has been saved and you can complete your order at any time.
          </p>
        </div>

        {intakeId && (
          <p className="text-sm mb-6" style={{ color: 'var(--color-muted)' }}>
            Reference ID: <span className="font-mono">{intakeId}</span>
          </p>
        )}

        <div className="space-y-3">
          <button
            onClick={() => navigate('/upload')}
            className="btn-primary w-full py-4"
            data-testid="cancel-upload-btn"
          >
            Return to Upload
          </button>
          <button
            onClick={() => navigate('/')}
            className="btn-secondary w-full py-4"
            data-testid="cancel-home-btn"
          >
            Return to Home
          </button>
        </div>

        <div className="mt-8 pt-8" style={{ borderTop: '1px solid var(--color-border)' }}>
          <p style={{ color: 'var(--color-muted)' }}>
            Need help? Contact us at{' '}
            <a href="mailto:team@schedulesofwork.com" className="font-medium hover:underline" style={{ color: 'var(--color-navy)' }}>
              team@schedulesofwork.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};
